import React from 'react';
import {classesState} from '../classesState';
import {ToggleGroup} from '../../components/togglegroup/index';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';
import InputLabel from '@material-ui/core/InputLabel';

const EXACT_CLASS_TXT = 'Konkrēta klase';

class Classes extends React.Component{
	constructor(props) {
		super(props);

		var allClasses = classesState.getAllClasses();

		var i = 0;
		this.allClasses = allClasses.map(function(item){
			i++;
			return (<MenuItem value={i} key={i} >{(item + '. klase')}</MenuItem>);
		})

		this.state = {
			classGroups: classesState.get().groups,
			activeClassesGroup: classesState.getActiveGroup(),
			singleClass: null,
		}

		this.activeGroupsChangeHandler = this.activeGroupsChangeHandler.bind(this);
	}
	componentDidMount() {

		classesState.on('activeGroupsChange', this.activeGroupsChangeHandler);
	}
	componentWillUnmount() {

		classesState.removeListener('activeGroupsChange', this.activeGroupsChangeHandler);
	}
	activeGroupsChangeHandler() {

			
			if(classesState.activeClasses.length === 1) {

				var singleClass = classesState.activeClasses[0];
			} else {
				var singleClass = null;
			}
			
			this.setState({
				activeClasses: classesState.activeClasses,
				activeClassesGroup: classesState.getActiveGroup(),
				singleClass: singleClass
			});
	}

	
	isActive(value) {
		return (this.state.activeClassesGroup.id === value);
	}
	toggleHandler(id, type) {

		classesState.setActiveGroupByID(id);
	}
	handleSelectChange(ev, val) {

		
		classesState.setActiveGroups([parseInt(val.key)]);
	}
	render() {

		var classGroups = [];
		for (var i = this.state.classGroups.length - 1; i >= 0; i--) {

			classGroups.push({id: this.state.classGroups[i].id, group: 'class', name: this.state.classGroups[i].name, childs:[], 
				classes: this.state.classGroups[i].classes,
				active: this.isActive(this.state.classGroups[i].id)
			});
		}

		return (<ToggleGroup
			clickItemHandler={this.toggleHandler.bind(this)} 
			menuItems={classGroups}
			name="Skolas pēc klašu grupas"
		>
			<div>
				<InputLabel shrink htmlFor="age-label-placeholder">
	            	{EXACT_CLASS_TXT}
	          	</InputLabel>
				<Select
			        value={this.state.singleClass}
			        onChange={this.handleSelectChange}
			        maxHeight={200}
			        style={{width: 180}}
			    //    floatingLabelText={EXACT_CLASS_TXT}
			    >
			        {this.allClasses}
		      	</Select>
			</div>
		</ToggleGroup>);
	}
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

  return {
  
  }
}

const MenuSection = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(Classes);

export default MenuSection;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/classes/container.js